<template>
  <Layout>
    <main>
      <section>
        <v-hero
          :imageSource="heroImage"
          :showBackgroundImage="!hasMoreThanOneLocation"
        >
          <div v-if="!hasMoreThanOneLocation">
            <img
              :class="{
                [$style['logo']]: true,
                [$style['wide']]: widerLogo,
              }"
              :src="`https:${logo}`"
            />
          </div>
          <div :class="$style['multiple-locations']" v-else>
            <img :class="$style['logo']" :src="`https:${logo}`" />
            <h1
              v-if="locationTitle"
              :class="$style['title']"
              v-color="colorFontHeading"
              v-font-style="fontDetailHeading"
              v-text="locationTitle"
            />
            <p
              v-if="locationLabel"
              :class="$style['label']"
              v-color="colorFontBody"
              v-font-style="fontDetailBody"
              v-text="locationLabel"
            />
            <h2
              v-if="locationName"
              :class="$style['name']"
              v-color="colorFontHeading"
              v-font-style="fontDetailHeading"
              v-text="locationName"
            />
            <v-button
              buttonText="change restaurant"
              :colorButton="colorSecondary"
              :colorButtonText="colorFontButton"
              :fontButton="fontDetailButton"
              secondary
              @buttonClick="$router.push('/')"
            />
          </div>
        </v-hero>
      </section>
      <section
        :class="{
          [$style['body']]: true,
          [$style['less-padding']]: !hasMoreThanOneLocation,
        }"
        v-background-color="bodyBackgroundColor"
      >
        <h1
          v-if="!hasMoreThanOneLocation"
          :class="$style['body-title']"
          v-color="colorFontHeading"
          v-font-style="fontDetailHeading"
          v-text="locationTitle"
        />
        <v-input
          :colorFont="colorFontBody"
          :colorPrimary="colorPrimary"
          :fontDetail="fontDetailBody"
          :label="tableLabel"
          :showArrow="canProceed"
          placeholder="Enter table number"
          inputmode="numeric"
          @input="handleInput"
          @formSubmit="handleButtonClick"
        />
        <p
          v-if="!tableNumberValid && tableNumberEntered"
          :class="$style['error-message']"
          v-font-style="fontDetailBody"
          >Oops, that table number doesn't exist. Please speak to your
          server.</p
        >
        <p
          v-if="tableBodyText"
          :class="$style['body-text']"
          v-color="colorFontBody"
          v-font-style="fontDetailBody"
          v-text="tableBodyText"
        />
      </section>
      <section v-if="!hasMoreThanOneLocation" :class="$style['footer']">
        <base-link :to="{ path: '/terms-and-conditions' }">
          <p
            :class="$style['terms-link']"
            v-color="colorFontBody"
            v-font-style="fontDetailBody"
            >Terms and conditions</p
          >
        </base-link>
      </section>
    </main>
  </Layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import get from 'lodash.get'
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import VButton from '@components/v-button.vue'
import VHero from '@components/v-hero.vue'
import VInput from '@components/v-input.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, VButton, VHero, VInput },
  data: () => ({
    location: null,
    tableNumberValid: false,
    tableNumberEntered: null,
  }),
  computed: {
    ...mapGetters('contentful', [
      'colorBackground',
      'colorFontBody',
      'colorFontButton',
      'colorFontHeading',
      'colorPrimary',
      'colorSecondary',
      'contentfulLoadingStatus',
      'fontDetailBody',
      'fontDetailButton',
      'fontDetailHeading',
      'hasMoreThanOneLocation',
      'heroImage',
      'locations',
      'locationLabel',
      'locationTitle',
      'logo',
      'widerLogo',
      'tableBodyText',
      'tableButtonText',
      'tableLabel',
    ]),
    bodyBackgroundColor() {
      if (this.hasMoreThanOneLocation) {
        return `#ffffff`
      }
      return this.colorBackground
    },
    canProceed() {
      if (this.tableNumberEntered && this.tableNumberValid) {
        return true
      }
      return false
    },
    locationName() {
      return get(this.location, 'fields.name') || ''
    },
  },
  methods: {
    ...mapActions('payment', ['resetPaymentData']),
    ...mapActions('ui', ['setPageLoadingStatus']),
    getLocationFromSlug() {
      const pageSlug = get(this.$route, 'params.slug')
      return this.locations.find((location) => {
        const locationSlug = get(location, 'fields.slug')
        return locationSlug === pageSlug
      })
    },
    handleButtonClick() {
      if (!this.tableNumberEntered) {
        return
      }
      this.proceedToBill()
    },
    handleInput(tableNumber) {
      this.tableNumberEntered = tableNumber

      // number between 1 - 10,000
      const regex = /^([1-9]|[1-8][0-9]|9[0-9]|[1-8][0-9]{2}|9[0-8][0-9]|99[0-9]|[1-8][0-9]{3}|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9]|10000)$/
      this.tableNumberValid = regex.test(tableNumber)
    },
    proceedToBill() {
      console.log('in proceed to bill')
      if (!this.tableNumberEntered) {
        console.log('in proceed to bill if block')
        return
      }
      this.$router.push(
        `/${this.$route.params.slug}/${this.tableNumberEntered}`
      )
    },
    init() {
      this.setPageLoadingStatus('loading')
      this.resetPaymentData()

      this.location = this.getLocationFromSlug()
      if (!this.location) {
        return this.$router.replace({ path: '/404' })
      }

      const status = get(this.location, 'fields.enabled')
      const locationIsEnabled = status === 'Enabled'
      if (!locationIsEnabled) {
        return this.$router.push({
          name: 'unavailable',
          params: { code: 'killswitch:location' },
        })
      }

      this.setPageLoadingStatus('loaded')
    },
  },
  watch: {
    contentfulLoadingStatus(newVal) {
      if (newVal === 'loaded') {
        this.init()
      }
    },
  },
  created() {
    if (this.contentfulLoadingStatus === 'loaded') {
      this.init()
    }
  },
}
</script>

<style lang="scss" module>
@import '@design';

.logo {
  width: 30%;
  margin-top: 25px;

  &.wide {
    width: 50%;
  }
}

.multiple-locations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 12px;
  background-color: transparent;

  .title {
    margin: 0;
    padding-top: 30px;
  }

  .logo {
    width: 62px;
    margin: 0;
  }

  .label {
    padding-top: 24px;
  }
}

.body {
  height: 50vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 46px 24px 0;

  .body-text {
    font-size: 14px;
    padding-top: 24px;
  }
}

.footer {
  width: 100%;
  padding-bottom: 16px;
  padding-top: 8px;

  .terms-link {
    font-size: 12px;
    text-align: center;
    text-decoration: underline;
  }
}

@media screen and (min-height: 560px) {
  .footer {
    bottom: 0;
    position: fixed;
  }
}

.error-message {
  padding-top: 8px;
  color: $color-error;
  font-size: 14px;
}

@media screen and (min-height: 700px) {
  section:first-of-type {
    max-height: 40vh;

    button {
      margin-top: 20px;
    }
  }

  .body {
    padding-top: 70px;
  }
}
</style>
